export default {
  gnb: {
    name: '獎勵點數',
    menu: {
      point: '點數',
      withdrawInfo: '提領',
      faq: 'FAQ',
      pointHistory: '點數記錄',
      pointExchangeHistory: '點數兌現記錄',
      userAuth: '身分驗證資訊',
    },
    login: '登入',
    logout: '登出',
  },
  fnb: {
    menu: {
      pointHistory: '點數記錄',
      pointExchangeHistory: '點數兌現記錄',
    },
  },
  footer: {
    useOfTerms: '條款及條件',
    userPolicy: '隱私權政策',
    operationPolicy: '營運政策',
  },
  common: {
    title: '我的點數',
    pointRedemptionInfo: '點數贖回相關資訊',
    textExpire: '於本月到期',
    textExpireGlobal: '即將到期',
    textExpiryInSettlement: '於本月到期 - 結算中',
    textLost: '於 {date} 到期',
    textInfo: '如何兌換點數',
    btnExchange: '申請兌現',
    btnSearch: '搜尋',
    btnDesc: '詳細資訊',
    confirm: '確定',
    cancel: '取消',
    next: '下一步',
  },
  date: {
    selectMonth: '選擇區間',
    year: '年',
    month: '月',
    middle: ' 至 ',
  },
  // page - intro
  intro: {
    title: '獎勵點數服務',
    desc: '可兌換現金的獎勵方案<br>真正的現金回饋獎勵',
    title_list: '獎勵點數',
    default_text: '没有獎勵點數服務。',
    initial_text: '請登入後確認獎勵點數。',
  },
  // page - 포인트 내역
  pointHistory: {
    statusList: ['賺取', '使用', '取消'],
    earn: '獲得 NEXON CREATORS',
    chargeCampaignPoint: '獲得 NEXON CREATORS CAMPAIGN',
    rewardPoint: '獲得 獎勵點數',
    chargeNConnectReward: 'N-CONNECT Reward',
    cancelEarn: '取消獲得 NEXON CREATORS',
    chargeCampaignPointMinus: '取消獲得 NEXON CREATORS CAMPAIGN',
    lostPoint: '喪失點數',
    expiredPoint: '到期點數',
    requestExchangePoint: '申請點數兌現',
    withdrawPersonBalance: '提領個人餘額',
    cancelRequestExchangePoint: '取消在 {date} 申請的點數兌現付款', //MM/DD/YYYY
    businessRegularProfit: '{month} {year} 的經常性營業利潤',
    withdrawBusinessBalance: '提領企業餘額',
    cancelBusinessRegularPayment: '取消 {month} {year} 的經常性營業利潤付款',
    chargeLiveDonation: '積分發放',
    chargeLiveDonationMinus: '點數回收',
    pointsIssued: '積分發放',
    pointsReclaim: '點數回收',
    expiryDate: '到期日',
    plus: '獲得',
    minus: '使用',
    cancel: '取消',
    subContentExtra: {
      cancelChargeByRefund: '因退款取消積分',
      withdrawCreator: '終止創作者狀態',
      resetIdentifyVerification: '身份驗證重置',
      failWithdrawal: '提領失敗',
      cancelGlobalExchangeRequest: '支付方式被拒絕',
      creatorSanction: '創作者懲處',
      policyViolation: '違反營運政策',
      // pointTransferOperations: '積分發放',
      // pointTransferAccountHolderChange: '積分發放',
      pointTransferOperations: '因營運移轉積分',
      pointTransferAccountHolderChange: '擁有人變更而轉入的積分',
    },
  },
  // page - 포인트 전환 내역
  exchangeHistory: {
    statusList: ['所有狀態', '申請', '正在準備', '付款已取消', '正在處理', '付款成功', '付款失敗', '無法付款'], // krpc
    globalStatusList: [
      '所有狀態',
      '申請',
      '進行中',
      '付款失敗',
      '付款成功',
      '無法付款',
      '付款已取消',
      '支付失敗（錯誤）',
    ], // global(krpc 외 계정)
    globalStatusRow: ['申請', '進行中', '付款成功', '付款已取消', '無法付款', '付款失敗', '支付失敗（錯誤）'], // 포인트 전환 내역에 뜨는 상태
    caution: {
      title: '企業使用者注意事項',
      content: `
        <li>企業使用者在上個月收集的點數將於當月第一天自動結算及兌換，且會自動建立點數兌現記錄。</li>
        <li>請查看詳細資訊，並將載明結算總額的電子稅務發票寄給我們，以利收取款項。</li>
        <li>請在每月 25日前將電子稅務發票寄至<a href="mailto:rewardpoint_tax@nexon.co.kr">rewardpoint_tax@nexon.co.kr</a>。</li>
        <li>若未開立任何稅務發票，則可能喪失該月份的收入或點數。</li>`,
      global: {
        title: '備註',
        content: `
            <p>[現金]</p>
            <li>提領核准後，將於次月15至20日開始進行作業，但由於是國際電匯，可能需要7天或更長的時間。</li>
            <li>由於電匯費用等因素，已要求的提領金額和收到的金額可能有所落差。</li>
            <li>您可以在查看詳細資訊頁面中確認進度詳情。</li>`,
        contentNexonPoint: `
            <p>[NEXON 點數]</p>
            <li>NEXON 點數轉換申請將於申請月份的 21 日後 10 個工作日內依序處理，並發放至正在進行創作者活動的帳號。</li>
            <li>由於需依序處理的關係，每位創作者的NEXON 點數發放時間可能不同。</li>`,
      },
    },
    requestExchangePoint: '申請點數兌現',
    businessRegularProfit: '{month} {year} 的經常性營業利潤',
    withdrawPersonBalance: '提領個人餘額',
    withdrawBusinessBalance: '提領企業餘額',
    global: {
      table: {
        column: {
          regiDate: '要求日期',
          status: '狀態',
          withdrawPoint: '已要求的提領點數',
          withdrawAmount: '已要求的提領金額',
          orderNo: '訂單編號',
          type: '提領類型',
        },
      },
    },
  },
  // page - 출금 정보
  userInfo: {
    needVerifiedId: '您需使用驗證 ID。<br/>前往「我的資訊」>「管理我的資訊」>「變更個人資訊」，並先自行驗證。',
    removeWithdrawalInfo: '確定要刪除提款資訊嗎？ 所有輸入的提款資訊都將被刪除。',
    underReview: '有一筆商業用戶申請尙未處理完成，處理期間無法刪除提款資訊。',
    processingCompleted: '處理已完成。',
  },
  // page - global
  global: {
    title: '點數提領申請',
    titlePoint: '申請轉換為NEXON 點數',
    subTitle: '申請提領',
    subTitlePoint: '轉換申請',
    mainText: `<span>點數可供兌換，</span>且可以現金方式提領。`,
    mainTextForNexonPoint: `<span>您可以將積分兌換成現金</span> 或轉換為 NEXON 點數。`,
    subText: `<span>請詳閱說明，並按一下「申請提領」</span>以前往下一個步驟。`,
    applyGuide: '提領申請說明',
    applyGuidePoint: 'NEXON 點數轉換申請指南',
    applyBtn: '申請提領',
    applyBtnPoint: '申请',
    pplyBtnPoint: '轉換申請',
    detailButton: '查看詳細資訊',
    available: '{pointName} 可用',
    withdrawPointInput: '輸入您想要提領的點數。',
    withdrawNjPointInput: '輸入轉換積分',
    withdrawAmount: '已要求的提領金額',
    withdrawAmountPoint: '申請NEXON 點數轉換的金額',
    transferFeeDescription: '由於電匯費用等因素，實際收到的金額可能有所落差。',
    transferFeeDescriptionPoint: '申請的金額將以 NEXON 點數發放。',
    confirmWithdrawCaution: '我已經閱讀了所有提領的注意事項。',
    confirmWithdrawCautionPoint: '我已確認所有積分轉換的重要注意事項。',
    withdrawCaution: '提領的注意事項',
    pointCaution: '有關 NEXON 點數轉換之注意事項',
    maxAmount: '最大金額',
    inputPlaceholder: '可由 {point}{unit} 輸入 ',
    withdrawCautionDescriptions: {
      1: '您一次可提領的金額下限為 {currency}{min}，上限為 {currency}{max}。',
      2: '一旦您申請提領點數，就不能取消。',
      3: '由於要扣除電匯費用，已要求的提領金額和收到的金額可能有所落差。',
      4: '若取得點數時涉及任何非法活動，或者申請資訊有問題 (例如銀行帳戶)，提領申請可能會遭到拒絕。',
      5: '提領申請的詳細資訊可以在您的點數兌現記錄中找到。',
      6: `
        <li>- 客戶在獎勵點數營利流程 (下稱「此流程」) 中所提供的資訊 (包括個人資訊，下稱「提供之資訊」) 僅限此流程和客戶支援使用。<br />
          這些提供之資訊依公司的
          <a
            href="https://company.nexon.co.jp/support/privacypolicy.html?_gl=1*1vcfzsa*_gcl_au*MTc5MzY4NDg5LjE3MDA4MDc3MzA"
            target="_blank"
          >個人資訊保護政策</a>進行管理。<br />
          提供之資訊會交予 Tipalti, Inc. (位於美國加州) 處理，此公司受託處理營利流程。<br />
          Tipalti, Inc. 會遵循 OECD 隱私權指引 (OECD Privacy Guidelines) 的八大基本原則採取行動。
        </li>
        <li>
          - 如要深入瞭解美國加州的個人資訊保護相關系統，敬請參考日本個人情報保護委員會發布之
          <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/" target="_blank">文件</a>。
        </li>
        <li>
          - 請將提供之資訊正確輸入。客戶如因輸入之內容有所不備，導致任何利益受損，公司恕不負責。
        </li>
      `,
    },
    withdrawPointCautionDescriptions: {
      1: '每次申請可轉換的範圍為 {min}{currency} 至 {max}{currency}。',
      2: '申請後無法取消。',
      3: '若發現積分累積涉及不當行為，提領申請可能會被拒絕。',
      4: '申請記錄可在積分提領記錄中查詢。',
    },
    modalHeader: '提款方式选择。',
    modalTitle: '請選擇提領方式。',
    modalDesc: '每月僅限申請一次。<br />請在慎重考慮後選擇申請方式。',
    cash: '現金',
    nexonPoint: 'NEXON 點數',
    nextStep: {
      1: '按一下 [下一步] 按鈕，輸入提領資訊。',
      2: '請提前參閱您需要輸入的提領資訊之指南。',
      3: '檢視提領資訊輸入指南',
    },
    nextStepForPoint: {
      1: `點擊「申请」按鈕，即可完成 NEXON 點數轉換申請。`,
      2: '您可以在以下指南中查看轉換申請的注意事項。',
      3: '申請指南',
    },
    withdrawFail: '處理時發生錯誤。<br/>請再試一次。',
    withdrawSuccessTitle: '已申請兌現點數。',
    withdrawSuccessTitlePoint: '您的點數贖回申請已完成。 ',
    withdrawSuccessDesc: '處理申請需求最多需要30分鐘，<br />可透過點數兌現記錄確認進行狀況。',
    withdrawSuccessDescPoint:
      'NEXON 點數將於當月 21 日之後，經過審核後發放至指定帳號。<br />您可以在積分轉換記錄中查看進度。',
    notAvailableCurrency: '您目前登入的帳號無法使用點數，<br/>抱歉造成您的不便。',
    notAvailableAge: '造成不便，敬請見諒。<br/>提領申請僅適用於 14 歲以上的會員。',
    notAvailablePeriod: '抱歉，但現在不是提款申請期間。請先確認申請期限。',
    notAvailableEmail:
      '此帳戶尚未完成電子郵件驗證。<br/>僅驗證過電子郵件的帳戶可以要求提領。<br/>請在 Nexon 帳戶設定選單中驗證您的電子郵件。',
    notAvailableWithdrawCount: '造成不便，敬請見諒。<br/>由於您已經超過每月提領要求限制，因此無法要求提領。',
    notAvailableEnoughPoint: '造成不便，敬請見諒。<br/>您的點數不足，無法要求提領。',
    otpGuide: '基於安全目的，您在設定 OTP 後必須輸入您的個人資訊。<br/>是否要設定 OTP？',
    notFinishedReviewAuth: '我們仍在審查您註冊的身分驗證資訊。<br/>您可以在此處理程序完成後再次註冊。',
    notRegisteredAuth:
      '身分驗證資訊尚未註冊。<br/>您可以在註冊身分驗證資訊且註冊資訊獲核准後要求撤銷。<br/>是否要註冊您的身分驗證資訊？',
    rejectedAuth:
      '您註冊的身分驗證資訊已遭拒絕。<br/>您可以在註冊身分驗證資訊且註冊資訊獲核准後要求撤銷。<br/>是否要編輯您的身分驗證資訊？',
    reApplicationAuth:
      '已針對您所註冊的身分驗證資訊要求重新申請。<br/>請查看電子郵件，確認要求重新申請的原因，並編輯您的身分驗證資訊。<br/>是否要編輯您的身分驗證資訊？ ',
    confirmingAuth: '我們目前正在確認您註冊的身分驗證資訊。<br/>請在身分驗證完成後要求撤銷。',
    noneOtp: '基於安全目的，您可以在設定 OTP 後要求撤銷。<br/>是否要設定 OTP？',
    validation: {
      minWithdrawPoint: '申請所需的最小數額為 {minValue}{unit}。',
      maxWithdrawPoint: '您所能申請的最大數額為 {maxValue}{unit}。',
      amountUnit: '申請以 {unitValue}{unit} 為單位。',
      notHasEnoughPoint: '您輸入的點數大於您擁有的點數。',
      withdrawing: '請稍待片刻。有申請正在進行中。',
      notAvailableApplication: '造成不便，敬請見諒。<br/>您無法以此帳戶要求提領。<br/>請參閱提領要求說明。',
      commonError: '造成不便，敬請見諒。發生未知錯誤。請稍後再試一次。',
    },
    exchangeRate: '匯率 {unitValue}{unit} = {currency}1',
    exchangePointRate: '匯率 {unitValue}{unit} = NEXON 點數 1{currency}',
  },
  error: {
    point: {
      1: '因服務維護，無法申請贊助積分兌換。請在維護完成後重試。',
      3001: '您需使用驗證 ID 才可申請點數兌現。<br>前往「我的資訊」>「管理我的資訊」>「變更個人資訊」，並先自行驗證。',
      3002: '未滿 14 歲的顧客不得申請點數兌現。',
      3004: '您的點數不足，無法申請點數兌現。',
      3005: '現金回饋獎勵每個月可申請一次。<br>您本月已申請過，無法再次申請。<br>請在點數兌現記錄中查看申請記錄。',
      3006: '您的點數不足，無法申請點數兌現。',
      3008: '申請點數兌現前，務必註冊使用者資訊與銀行帳戶資訊。<br>是否要立即註冊？',
      3009: '企業使用者無法申請點數兌現。<br>企業使用者在上個月收集的點數將於當月的第一天自動兌換，而收入可透過電子稅務發票申領。',
      3013: '申請所需的最小數額為 {minValue}{unit}。',
      3015: '抱歉，但現在不是提款申請期間。請先確認申請期限。',
      3017: '등록된 출금정보의 이름이 현재 회원정보와 일치하지 않습니다.<br>출금정보를 업데이트 해주세요.',
      default: '造成不便，敬請見諒。<br>發生未知錯誤，無法申請點數兌現。<br>請稍後再試一次。',
    },
    pointHistory: {
      0: '沒有點數記錄。',
      1: '目前此服務正在維護，因此無法檢視點數記錄。<br>請在維護結束後再試一次。',
      default: '造成不便，敬請見諒。<br>發生未知錯誤，無法擷取記錄。<br>請稍後再試一次。',
    },
    exchangeHistory: {
      0: '沒有點數兌現記錄。',
      1: '目前此服務正在維護，因此無法檢視點數兌現記錄。<br>請在維護結束後再試一次。',
      default: '造成不便，敬請見諒。<br>發生未知錯誤，無法申請點數贖回。<br>請稍後再試一次。',
    },
    search: {
      day: '最大搜尋期間為 31 天。<br>請修改日期。',
      month: '最大搜尋期間為 12 個月。<br>請修改日期。',
    },
    common: {
      temporaryError: '發生暫時性的錯誤，請稍後再試。',
      needLogin: '請問您是否想前往登入頁？',
      needIdentity: '請驗證你的身份。',
      serviceNotAvailable: '該服務目前無法使用。',
      notPossiblePointConversion: '無法申請贊助積分兌換。',
      retry: '請再試一次。',
      serviceConnectionError: '因服務連線錯誤無法完成，請稍後再試。',
      maintenance: '我們目前正在進行維護。',
      maintenanceDescription: '此服務正在維護中，造成您的不便還請見諒。',
      errorPath: '此為無效的路徑。',
    },
    // 임시 에러 메시지
    temp: {
      global: '造成不便，敬請見諒。<br>此次無法申請提領。<br>提領功能將於約六月時上線。',
    },
  },
};
